import React, { useState, useEffect, useContext } from "react";
import { createPortal } from "react-dom";

import { useAppSelector } from "@litres-core/store";
import { useHasWindow, useLocation } from "@litres-libs/global-hooks";

import { useTranslation } from "@litres-libs/i18n";
import { useGetUserMonetizationData } from "../../../hooks/useGetUserMonetizationData";
import { Tab } from "../../Tab";
import { TABS } from "../../Tab/constants";
import type { TabsType } from "../../Tab/types";
import { getIsEnabledShowNavBarMobile } from "./utils";
import { HeaderContext } from "../../../Header";

import styles from "./NavBarMobile.module.scss";

export const NavBarMobile = (): JSX.Element | null => {
  const { t } = useTranslation();
  const hasWindow = useHasWindow();
  const location = useLocation();
  const { isLibraryDomain, isSchoolDomain } = useContext(HeaderContext);
  const {
    id: userId,
    LKS,
    BSK,
    library_info: { is_school_user: isSchoolUser },
  } = useAppSelector(state => state.foundationUser);
  const { data: userMonetizationData } = useGetUserMonetizationData();
  const isUserAnonymous = userId === 0;
  const [pathname, setPathname] = useState("");
  useEffect(() => {
    // FIXME: Без "костыля" не работает при первом рендере выделение активного таба, возможно ошибки гидрации некста
    setPathname(location?.pathname || "");
  }, [location?.pathname]);

  const isEnabledShow = getIsEnabledShowNavBarMobile(pathname);

  const favoriteCount = isUserAnonymous
    ? LKS.length
    : userMonetizationData?.cart_stats?.deferred_count;
  const basketCount = isUserAnonymous
    ? BSK.length
    : userMonetizationData?.cart_stats?.items_count;

  let tabs: { type: TabsType; count: number | null | undefined }[] = [
    { type: "main", count: null },
    { type: "catalog", count: null },
    { type: "favorite", count: favoriteCount },
    { type: "basket", count: basketCount },
    {
      type: "myBooks",
      count: userMonetizationData?.bought_collections.length,
    },
  ];

  // На школьном и библио доменах не показываем корзину
  if (isSchoolDomain || isSchoolUser || isLibraryDomain) {
    tabs = tabs.filter(({ type }) => type !== "basket");
  }

  const columnWidth = 100 / tabs.length;

  if (!isEnabledShow) {
    return null;
  }

  return (
    <>
      <nav
        className={styles.navBarMobile}
        style={{
          gridTemplateColumns: `repeat(${tabs.length},${columnWidth}%)`,
        }}
        aria-label={t("Пользовательские разделы меню")}
      >
        {tabs.map(({ type, count }) => (
          <Tab
            key={type}
            type={type}
            theme="orange"
            isActive={pathname === TABS[type].href}
            count={count}
          />
        ))}
      </nav>
      {hasWindow &&
        createPortal(
          <div className={styles.navBarMobile__safeArea} />,
          document.body
        )}
    </>
  );
};
